<template>
  <v-dialog
    :value="dialog"
    :max-width="1000"
    @input="$emit('update:dialog')"
    scrollable
  >
    <v-card class="orders" max-width="1000px" v-if="!loading">
      <v-card-title class="py-0 justify-center">
        <span class="secondary--text font-bold pt-2">
          {{ $t("order_details") }}</span
        >
      </v-card-title>
      <v-card-subtitle class="mt-1">
        <h3 class="text-center primary--text">
          {{ trip_order.trip_name }}
        </h3>
      </v-card-subtitle>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" lg="8">
              <v-row>
                <v-col cols="12" lg="3">
                  <v-chip class="error orders__title">
                    <span class="white--text font-bold">
                      {{ $t("invoice_and_detials") }}
                    </span>
                  </v-chip>
                </v-col>
                <v-col cols="12">
                  <v-card flat class="orders__invoice">
                    <v-container>
                      <v-row>
                        <v-col cols="12" lg="6">
                          <span class="secondary--text size-16 weight-800">
                            {{ $t("table.trip_date") }}
                          </span>
                        </v-col>
                        <v-col cols="12" lg="6" class="text-center">
                          <span class="secondary--text size-16 weight-800">
                            {{ convertDate(trip_order.starts_at) }}
                          </span>
                        </v-col>
                        <v-col cols="12" lg="6">
                          <span class="secondary--text size-16 weight-800">
                            {{ $t("table.persons_count") }}
                          </span>
                        </v-col>
                        <v-col cols="12" lg="6" class="text-center">
                          <span class="secondary--text size-16 weight-800">
                            {{ `${trip_order.persons_count} ${$t("persons")}` }}
                          </span>
                        </v-col>
                        <v-col cols="12" lg="6">
                          <span class="secondary--text size-16 weight-800">
                            {{ $t("table.children_count") }}
                          </span>
                        </v-col>
                        <v-col cols="12" lg="6" class="text-center">
                          <span class="secondary--text size-16 weight-800">
                            {{
                              `${trip_order.children_count} ${$t("children")}`
                            }}
                          </span>
                        </v-col>
                        <v-col
                          cols="12"
                          lg="6"
                          class="align-self-center d-flex"
                        >
                          <span class="secondary--text size-16 weight-800">
                            {{ $t("table.trip_price_per_person") }}
                          </span>
                        </v-col>
                        <v-col cols="12" lg="6" class="py-0">
                          <v-list flat class="transparent pa-0 mx-0">
                            <v-list-item class="px-0">
                              <v-list-item-content>
                                <v-list-item-title>
                                  <span
                                    class="primary--text size-16 weight-800"
                                  >
                                    {{ trip_order.trip_person_price }}
                                  </span>
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-col>
                        <v-col
                          cols="12"
                          lg="6"
                          class="align-self-center d-flex"
                        >
                          <span class="secondary--text size-16 weight-800">
                            {{ $t("table.trip_price_per_child") }}
                          </span>
                        </v-col>
                        <v-col cols="12" lg="6" class="py-0">
                          <v-list flat class="transparent pa-0 mx-0">
                            <v-list-item class="px-0">
                              <v-list-item-content>
                                <v-list-item-title>
                                  <span
                                    class="primary--text size-16 weight-800"
                                  >
                                    {{ trip_order.trip_child_price }}
                                  </span>
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-card-actions class="px-0 mx-0 d-flex flex-wrap">
                      <v-col cols="12" lg="6" class="align-self-center d-flex">
                        <span class="error--text size-16 weight-800">
                          {{ $t("table.total_price") }}
                        </span>
                      </v-col>
                      <v-col cols="12" lg="6" class="py-0">
                        <v-list flat class="transparent pa-0 mx-0">
                          <v-list-item class="px-0">
                            <v-list-item-content>
                              <v-list-item-title>
                                <span class="error--text size-16 weight-800">
                                  {{ trip_order.sub_total }}
                                </span>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-col>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
              <!-- special order -->
              <!-- <v-row v-if="trip_order.over_prices.length > 0">
                <v-col cols="12" lg="3">
                  <v-chip class="error orders__title">
                    <span class="white--text font-bold">
                      {{ $t("special_order") }}
                    </span>
                  </v-chip>
                </v-col>
                <v-col cols="12">
                  <v-card flat class="orders__invoice">
                    <v-container>
                      <v-row
                        v-for="(over_price, index) in trip_order.over_prices"
                        :key="index"
                      >
                        <v-col
                          cols="12"
                          lg="6"
                          class="align-self-center d-flex"
                        >
                          <span class="secondary--text size-16 weight-800">
                            {{ over_price.reason }}
                          </span>
                        </v-col>
                        <v-col cols="12" lg="6" class="py-0">
                          <v-list flat class="transparent pa-0 mx-0">
                            <v-list-item class="px-0">
                              <v-list-item-content>
                                <v-list-item-title>
                                  <span
                                    class="primary--text size-16 weight-800"
                                  >
                                    {{ over_price.value }}
                                  </span>
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-card-actions class="px-0 mx-0 d-flex flex-wrap">
                      <v-col cols="12" lg="6" class="align-self-center d-flex">
                        <span class="error--text size-16 weight-800">
                          {{ $t("table.total_price") }}
                        </span>
                      </v-col>
                      <v-col cols="12" lg="6" class="py-0">
                        <v-list flat class="transparent pa-0 mx-0">
                          <v-list-item class="px-0">
                            <v-list-item-content>
                              <v-list-item-title>
                                <span class="error--text size-16 weight-800">
                                  {{ trip_order.grand_total }}
                                </span>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-col>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row> -->
              <!-- order details -->
              <v-row>
                <v-col cols="12" lg="3">
                  <v-chip class="error orders__title">
                    <span class="white--text font-bold">
                      {{ $t("details_trip") }}
                    </span>
                  </v-chip>
                </v-col>
                <v-col cols="12">
                  <v-card flat class="orders__invoice">
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-row>
                            <v-col cols="12" lg="6">
                              <h3 class="secondary--text">
                                {{ trip_order.trip && trip_order.trip.name }}
                              </h3>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          v-if="trip_order.trip && trip_order.trip.media"
                        >
                          <v-card class="orders__media-card" v-if="dialog">
                            <MediaSlider :items="trip_order.trip.media" />
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" lg="6">
                          <div class="d-flex align-center">
                            <img
                              width="30px"
                              height="30px"
                              :src="require('@/assets/imgs/trips/persons.png')"
                              alt="photo"
                            />
                            <span class="px-2">
                              {{ $t("person_price") }}
                            </span>
                            <span class="primary--text font-bold">
                              {{
                                trip_order.trip && trip_order.trip.person_price
                              }}
                            </span>
                          </div>
                        </v-col>
                        <v-col cols="12" lg="6">
                          <div class="d-flex align-center">
                            <img
                              width="30px"
                              height="30px"
                              :src="
                                require('@/assets/imgs/trips/children_price.png')
                              "
                              alt="photo"
                            />
                            <span class="px-2">
                              {{ $t("child_price") }}
                            </span>
                            <span class="primary--text font-bold">
                              {{
                                trip_order.trip && trip_order.trip.child_price
                              }}
                            </span>
                          </div>
                        </v-col>
                        <v-col cols="12" lg="6">
                          <div class="d-flex align-center">
                            <img
                              width="30px"
                              height="30px"
                              :src="require('@/assets/imgs/trips/duration.png')"
                              alt="photo"
                            />
                            <span class="px-2">
                              {{ $t("duration") }}
                            </span>
                            <span class="primary--text font-bold">
                              {{
                                trip_order.trip &&
                                  trip_order.trip.duration_in_hours
                              }}
                              {{ $t("hour") }}
                            </span>
                          </div>
                        </v-col>
                                <v-col cols="12" lg="6">
                          <div class="d-flex align-center">
                          
                            <span class="px-2">
                              {{ $t("meeting_point") }}
                            </span>
                            <span class="primary--text font-bold">
                              {{
                               trip_order && trip_order.meeting_point
                              }}
                            </span>
                          </div>
                        </v-col>
                                         <v-col cols="12" lg="6">
                          <div class="d-flex align-center">
                          
                            <span class="px-2">
                              {{ $t("starts_at") }}
                            </span>
                            <span class="primary--text font-bold">
                              {{
                               trip_order && new Date(trip_order.starts_at).toLocaleString()
                              }}
                            </span>
                          </div>
                        </v-col>
                        <v-col
                          cols="12"
                          lg="6"
                          v-if="trip_order.trip && trip_order.trip.tourism_city"
                        >
                          <div class="d-flex align-center">
                            <img
                              width="30px"
                              height="30px"
                              :src="require('@/assets/imgs/trips/city.png')"
                              alt="photo"
                            />

                            <span class="primary--text font-bold px-2">
                              {{ trip_order.trip.tourism_city.name }}
                            </span>
                          </div>
                        </v-col>
                        
                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
                <template v-if="trip_order.has_special_request">
                  <v-col cols="12" lg="3">
                    <v-chip class="error orders__title">
                      <span class="white--text font-bold">
                        {{ $t("special_order") }}
                      </span>
                    </v-chip>
                  </v-col>
                  <v-col>
                    <p>{{ trip_order.special_request_details }}</p>
                  </v-col>
                </template>
              </v-row>
              <user-details :userDetails="trip_order.user" v-if="Object.keys(trip_order.user).length" />
            </v-col>
            <v-col cols="12" lg="4">
              <v-row>
                <v-col cols="12" lg="3">
                  <v-chip class="error orders__title">
                    <span class="white--text font-bold">
                      {{ $t("order_status") }}
                    </span>
                  </v-chip>
                </v-col>
              </v-row>
              <v-row style="height: 97%">
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12">
                      <OrderStatus :item="trip_order" />
                    </v-col>
                    <v-col cols="12">
                      <v-btn
                        @click="handleAcceptOrder"
                        depressed
                        block
                        large
                        class="success"
                        :disabled="trip_order.accepted"
                      >
                        <span class="white--text font-bold">
                          {{ $t("accept") }}
                        </span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" v-if="trip_order.has_special_request">
              <overPrices :order="trip_order" />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card min-height="200px" max-width="1000px" v-else>
      <loader class="h-100" />
    </v-card>
  </v-dialog>
</template>

<script>
import { IndexData, StoreData } from "@/helpers/apiMethods";
export default {
  name: "TripsOrder",
  components: {
    OrderStatus: () => import("./Status.vue"),
    overPrices: () => import("./overPrices.vue"),
    UserDetails : () => import("../sharedCmp/userDetails.vue")
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      trip_order: {},
      loading: true
    };
  },
  methods: {
    handleAcceptOrder() {
      const formData = new FormData();
      formData.append("_method", "put");
      formData.append("accept", 1);
      this.popUp().then(value => {
        if (!value.dismiss) {
          StoreData({
            reqName: `trip-orders/${this.trip_order.reference_number}`,
            data: formData
          })
            .then(() => {
              this.$emit("update:dialog");
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    handleShow() {
      IndexData({ reqName: `trip-orders/${this.item.reference_number}` })
        .then(res => {
          const { trip_order } = res.data;
          this.trip_order = trip_order;
          console.log(trip_order);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  watch: {
    dialog: {
      handler(value) {
        if (value) {
          this.handleShow();
        } else {
          this.loading = true;
          this.$emit("refresh-table");
        }
      },
      immediate: false
    }
  }
};
</script>
